// src/utils/appKeys.js
const STORAGE_KEY = "app_keys";

export const setAppKeys = (keys) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(keys || {}));
  } catch (e) {
    console.warn("setAppKeys failed", e);
  }
};

export const getAppKeys = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

export const getGoogleMapsApiKey = () => getAppKeys()?.googleMapsApiKey || "";
export const getWeatherApiKey = () => getAppKeys()?.weatherApiKey || "";
export const getShareApiKey = () => getAppKeys()?.shareApiKey || "";
